import { render } from "./AccountByCompanyPage.vue?vue&type=template&id=c87702dc&ts=true"
import script from "./AccountByCompanyPage.vue?vue&type=script&lang=ts"
export * from "./AccountByCompanyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__